import lozad from "lozad";
export default function (selector) {
    selector = selector ? selector : '.lozad';
    return new Promise((resolve) => {
        const observer = lozad(selector);
        observer.observe();
        resolve(selector);
    });
};